import React, {lazy} from 'react'
import {BrowserRouter as Router, Switch, Route} from 'react-router-dom'
import Navbar from './components/navbar/index'
import Footer from './components/footer/index'
import Error from './components/more/error'
import SelectPackage from "./components/buy-course/selectPackage";
import SelectSubscription from "./components/buy-course/selectSubsciption";
import Loader from "./components/loader";
import LearnFrench from "./components/language-classes/learnFrench"

import * as PropTypes from "prop-types";
import AbroadApplicationForm from "./components/language-classes/abroad/AbroadApplicationForm";
//Components
const Homepage = lazy(() => import('./components/homepage/index'));
const French = lazy(() => import('./components/language-classes/french'));
const IELTS = lazy(() => import('./components/language-classes/ielts'));
const English = lazy(() => import('./components/language-classes/english'));
const Exams = lazy(() => import('./components/exams/index'));
const Interactiveclass = lazy(() => import('./components/math_science/interactive_class'));
const Democlass = lazy(() => import('./components/demo-vid/index'));
const Liveclass = lazy(() => import('./components/math_science/liveclass'));
const After10 = lazy(() => import('./components/career-guidance/after_10'));
const Studyabroad = lazy(() => import('./components/career-guidance/study_abroad'));
const Portfolio = lazy(() => import('./components/career-guidance/portfolio'));
const Buycourse = lazy(() => import('./components/buy-course/index'));
const Studycenter = lazy(() => import('./components/study-center/index'));
// const Blog = lazy(() => import('./components/more/blog'));
const Blog = lazy(() => import('./components/more/blogPages/BlogsTemplate'));
const Hiring = lazy(() => import('./components/more/we_r_hiring'));
const Contact = lazy(() => import('./components/more/contact'));
const OurBranches = lazy(() => import('./components/more/branches'));
const Privacypolicy = lazy(() => import('./components/more/privacy_policy'));
const Userprofile = lazy(() => import('./components/account/profile'));
const Class5 = lazy(() => import('./components/syllabus/class5'));
const Class6 = lazy(() => import('./components/syllabus/class6'));
const Class7 = lazy(() => import('./components/syllabus/class7'));
const Class8 = lazy(() => import('./components/syllabus/class8'));
const Class9 = lazy(() => import('./components/syllabus/class9'));
const Class9demo = lazy(() => import('./components/demo-vid/demo-9/index'));
const Class10 = lazy(() => import('./components/syllabus/class10'));
const Class10demo = lazy(() => import('./components/demo-vid/demo-10/index'));
const OTPVerify = lazy(() => import('./components/otpVerify/index'));
const Learning = lazy(() => import('./components/learning/learning'));
const Competitive = lazy(() => import('./components/learning/competitive'));
const EnrollmentConfirmation = lazy(() => import('./components/enrollment_confirmation/index'));
const Sharecode = lazy(() => import('./components/share_code/index'));
const BookFreeClass = lazy(() => import('./components/bookClass/index'));
const AbroadEnquiry = lazy(() => import('./components/language-classes/abroad_enquiry'));
const InquiryReceived = lazy(() => import('./components/more/inquiryReceived'));


class NotFound extends React.Component {
    render() {
        return (
            <Error/>
        )
    }
}


function Links() {
    const navRef = React.createRef();
    return (
        <React.Suspense fallback={<Loader/>}>
            <Router>
                <Switch>
                    <Route
                        exact
                        path="/send_otp"
                        render={props => (
                            <OTPVerify {...props} component={OTPVerify} title="Send OTP | CareerDose"/>
                        )}
                    />
                    <Route
                        exact
                        path="/learning"
                        render={props => (
                            <Learning {...props} component={Learning} title="Learning | CareerDose"/>
                        )}
                    />
                    <Route
                        exact
                        path="/competitive"
                        render={props => (
                            <Competitive {...props} component={Competitive} title="Competitive | CareerDose"/>
                        )}
                    />

                    <Route
                        exact
                        path="/enrollment_confirmation"
                        render={props => (
                            <EnrollmentConfirmation {...props} component={EnrollmentConfirmation}
                                                    title="Enrollment Confirmation | CareerDose"/>
                        )}
                    />
                    <Route
                        exact
                        path="/share_code"
                        render={props => (
                            <Sharecode {...props} component={Sharecode} title="Share Code | CareerDose"/>
                        )}
                    />
                    <Route
                        exact
                        path="/study_abroad"
                        render={props => (
                            <AbroadEnquiry {...props} component={AbroadEnquiry} title="Abroad Enquiry | CareerDose"/>
                        )}
                    />
                    <Route
                        exact
                        path="/language_class/french"
                        render={props => (
                            <LearnFrench {...props} component={LearnFrench} title="Learn French | CareerDose"/>
                        )}
                    />

                    {/*<Route*/}
                    {/*    exact*/}
                    {/*    path="/select-package"*/}
                    {/*    render={props => (*/}
                    {/*        <SelectPackage {...props} component={SelectPackage} title="Select Package | CareerDose" />*/}
                    {/*    )}*/}
                    {/*/>*/}
                    {/*<Route*/}
                    {/*    exact*/}
                    {/*    path="/select-subscription"*/}
                    {/*    render={props => (*/}
                    {/*        <SelectSubscription {...props} component={SelectSubscription} title="Select Subscription | CareerDose" />*/}
                    {/*    )}*/}
                    {/*/>*/}
                    <Route
                        exact
                        path="/language_class/ielts"
                        render={props => (
                            <IELTS {...props} component={IELTS} title="Ielts | Career Dose"/>
                        )}
                    />
                    <Route path={"/"}>
                        <Navbar/>
                        <Switch>
                            <Route
                                exact
                                path="/"
                                render={props => (
                                    <Homepage {...props} component={Homepage} title="Home | Career Dose"/>
                                )}
                            />
                            <Route
                                exact
                                path="/exams"
                                render={props => (
                                    <Exams {...props} component={Exams} title="Exams | Career Dose"/>
                                )}
                            />

                            <Route
                                exact
                                path="/language_class/english"
                                render={props => (
                                    <English {...props} component={English} title="English | Career Dose"/>
                                )}
                            />
                            <Route
                                exact
                                path="/interactive_class"
                                render={props => (
                                    <Interactiveclass {...props} component={Interactiveclass}
                                                      title="Interactive Class | Career Dose"/>
                                )}
                            />
                            <Route
                                exact
                                path="/demo_class"
                                render={props => (
                                    <Democlass {...props} component={Democlass} title="Demo Class | Career Dose"/>
                                )}
                            />
                            <Route
                                exact
                                path="/live_class"
                                render={props => (
                                    <Liveclass {...props} component={Liveclass} title="LIVE Class | Career Dose"/>
                                )}
                            />
                            <Route
                                exact
                                path="/after_10"
                                render={props => (
                                    <After10 {...props} component={After10} title="After 10th | Career Dose"/>
                                )}
                            />
                            <Route
                                exact
                                path="/abroad/application_form"
                                render={props => (
                                    <AbroadApplicationForm {...props} component={AbroadApplicationForm} title="Application Form Abroad | Career Dose"/>
                                )}
                            />
                            {/*<Route*/}
                            {/*    exact*/}
                            {/*    path="/study_abroad"*/}
                            {/*    render={props => (*/}
                            {/*        <Studyabroad {...props} component={Studyabroad}*/}
                            {/*            title="Study Abroad | Career Dose" />*/}
                            {/*    )}*/}
                            {/*/>*/}
                            <Route
                                exact
                                path="/portfolio_management"
                                render={props => (
                                    <Portfolio {...props} component={Portfolio}
                                               title="Portfolio Management | Career Dose"/>
                                )}
                            />
                            <Route
                                exact
                                path="/buy_course"
                                render={props => (
                                    <Buycourse {...props} component={Buycourse} title="Buy Course | Career Dose"/>
                                )}
                            />
                            <Route
                                exact
                                path="/inquiry-received"
                                render={props => (
                                    <InquiryReceived {...props} component={InquiryReceived}
                                                     title="Thanks for reaching out! | Career Dose"/>
                                )}
                            />
                            <Route
                                exact
                                path="/study_center"
                                render={props => (
                                    <Studycenter {...props} component={Studycenter}
                                                 title="Study Center | Career Dose"/>
                                )}
                            />
                            <Route
                                exact
                                path="/blogs"
                                render={props => (
                                    <Blog {...props} component={Blog} title="Blogs | Career Dose"/>
                                )}
                            />
                            <Route
                                exact
                                path="/hr_careerdose"
                                render={props => (
                                    <Hiring {...props} component={Hiring} title="We Are Hiring | Career Dose"/>
                                )}
                            />
                            <Route
                                exact
                                path="/contact_us"
                                render={props => (
                                    <Contact {...props} component={Contact} title="Contact Us | Career Dose"/>
                                )}
                            />
                            <Route
                                exact
                                path="/our_branches/darbhanga"
                                render={({props}) => (
                                    <OurBranches {...props} component={OurBranches}
                                                 title="Our Branches | Career Dose"/>
                                )}
                            />
                            <Route
                                exact
                                path="/privacy_policy"
                                render={props => (
                                    <Privacypolicy {...props} component={Privacypolicy}
                                                   title="Privacy Policy | Career Dose"/>
                                )}
                            />
                            <Route
                                exact
                                path="/my_profile"
                                render={props => (
                                    <Userprofile {...props} component={Userprofile}
                                                 title="My Profile | Career Dose"/>
                                )}
                            />
                            <Route
                                exact
                                path="/class5_syllabus"
                                render={props => (
                                    <Class5 {...props} component={Class5} title="Class 5 - Syllabus | CareerDose"/>
                                )}
                            />
                            <Route
                                exact
                                path="/class6_syllabus"
                                render={props => (
                                    <Class6 {...props} component={Class6} title="Class 6 - Syllabus | CareerDose"/>
                                )}
                            />
                            <Route
                                exact
                                path="/class7_syllabus"
                                render={props => (
                                    <Class7 {...props} component={Class7} title="Class 7 - Syllabus | CareerDose"/>
                                )}
                            />
                            <Route
                                exact
                                path="/class8_syllabus"
                                render={props => (
                                    <Class8 {...props} component={Class8} title="Class 8 - Syllabus | CareerDose"/>
                                )}
                            />
                            <Route
                                exact
                                path="/class9_syllabus"
                                render={props => (
                                    <Class9 {...props} component={Class9} title="Class 9 - Syllabus | CareerDose"/>
                                )}
                            />
                            <Route
                                exact
                                path="/class9_demo"
                                render={props => (
                                    <Class9demo {...props} component={Class9demo}
                                                title="Class 9 - Demo | CareerDose"/>
                                )}
                            />
                            <Route
                                exact
                                path="/class10_syllabus"
                                render={props => (
                                    <Class10 {...props} component={Class10}
                                             title="Class 10 - Syllabus | CareerDose"/>
                                )}
                            />
                            <Route
                                exact
                                path="/class10_demo"
                                render={props => (
                                    <Class10demo {...props} component={Class10demo}
                                                 title="Class 10 - Demo | CareerDose"/>
                                )}
                            />
                            <Route
                                exact
                                path="/book_free_class"
                                render={props => (
                                    <BookFreeClass {...props} component={BookFreeClass}
                                                   title="Book Free Class | Career Dose"/>
                                )}
                            />
                            <Route
                                path="/"
                                render={props => <NotFound/>}
                            />
                        </Switch>
                        <Footer ref={navRef}/>
                    </Route>
                </Switch>
            </Router>

        </React.Suspense>
    )
}

export default Links;
